module.exports = __webpack_public_path__ + "static/media/home-background-nb.03113566.png";